import { useIntl } from 'react-intl';

import { Box } from '@/components/Box';
import { Typography } from '@/components/Typography';
import { useRouter } from '@/hooks/useRouter';
import { commonMessages } from '@/messages/appointment';
import { messages } from '@/messages/notifyMe';
import { userState } from '@/states/user';

import * as S from './SubscribedState.styles';

type SubscribedStateProps = {
  caseMaterial: string;
  dialColor: string;
  nameWithSalutation: string;
  onClose: () => void;
  productName: string;
};
export const SubscribedState = ({
  caseMaterial,
  dialColor,
  nameWithSalutation,
  onClose,
  productName,
}: SubscribedStateProps) => {
  const { formatMessage } = useIntl();
  const { paths, push, query } = useRouter();
  const navToCollection = () => {
    push(paths.watches.collection.asPath({ slug: query.collection as string }));
    onClose();
  };
  return (
    <>
      <Box data-testid='SubscribedStateBox'>
        <Typography
          color='secondary'
          data-testid='SubscribedStateProductName'
          fontWeight='regular'
          mt={4}
          scale='h5'
          textAlign='center'
          textTransform='uppercase'
        >
          {productName}
        </Typography>
        <Typography
          color='secondary'
          data-testid='SubscribedStateCaseMaterial-DialColor'
          fontWeight='regular'
          mb={2}
          scale='h5'
          textAlign='center'
          textTransform='uppercase'
        >
          {caseMaterial} - {dialColor}
        </Typography>
        <Typography
          color='default'
          data-testid='SubscribedStateFirstToKnow'
          textAlign='center'
        >
          {formatMessage(messages.firstToKnow)}
        </Typography>
        <Typography
          color='secondary'
          data-testid='SubscribedStateSalutationName'
          fontWeight='bold'
          mt={4}
          scale='h5'
          textAlign='center'
          textTransform='uppercase'
        >
          {nameWithSalutation}
        </Typography>
        <Typography
          color='default'
          data-testid='SubscribedStateMsg'
          textAlign='center'
        >
          {userState.isAuthenticated
            ? formatMessage(messages.subscribedMsg)
            : formatMessage(messages.subscribedMsgGuest)}
        </Typography>
      </Box>
      <S.FlexButtonBox data-testid='SubscribedStateFlexButtonBox'>
        <S.DiscoverButton
          data-testid='SubscribedStateDiscoverCollections'
          onClick={navToCollection}
          size='l'
        >
          {formatMessage(commonMessages.discoverCollections)}
        </S.DiscoverButton>
      </S.FlexButtonBox>
    </>
  );
};
